import React, { useEffect } from "react";
import {
  useDispatch,
  useSelector,
} from "react-redux";

import {
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";

import Header from "../components/Header";
import Leftnav from "../components/Leftnav";
import Rightchat from "../components/Rightchat";
import Popupchat from "../components/Popupchat";
import Appfooter from "../components/Appfooter";
import Postview from "../components/Postview";

import {
  getClubPublicPosts,
} from "../redux/slices/clubSlice";

import { RootState } from "../redux/store";

// ==========================
// API BASE URL
// ==========================
const API_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
)
  .replace(/\/uploads\/?$/, "")
  .replace(/\/$/, "");

// ==========================
// UPLOAD URL HELPER
// ==========================
const getUploadUrl = (
  file?: string | null
): string | undefined => {
  if (
    !file ||
    String(file).trim() === ""
  ) {
    return undefined;
  }

  const value =
    String(file).trim();

  // Already full URL
  if (
    value.startsWith("http://") ||
    value.startsWith("https://")
  ) {
    return encodeURI(value);
  }

  // /uploads/file.jpg
  if (
    value.startsWith("/uploads/")
  ) {
    return encodeURI(
      `${API_URL}${value}`
    );
  }

  // uploads/file.jpg
  if (
    value.startsWith("uploads/")
  ) {
    return encodeURI(
      `${API_URL}/${value}`
    );
  }

  // Known direct folders
  if (
    value.startsWith("designs/") ||
    value.startsWith("documents/") ||
    value.startsWith("banners/") ||
    value.startsWith("logos/") ||
    value.startsWith("profile-photos/")
  ) {
    return encodeURI(
      `${API_URL}/uploads/${value}`
    );
  }

  // /other/path/file
  if (
    value.startsWith("/")
  ) {
    return encodeURI(
      `${API_URL}${value}`
    );
  }

  // filename.jpg
  return encodeURI(
    `${API_URL}/uploads/${value}`
  );
};

// ==========================
// STRIP HTML
// ==========================
const stripHtml = (
  html = ""
) => {
  return html
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();
};

const ClubPosts: React.FC = () => {
  const dispatch =
    useDispatch<any>();

  const navigate =
    useNavigate();

  const location =
    useLocation();

  const {
    client_id,
  } = useParams<{
    client_id: string;
  }>();

  const club =
    location.state?.club;

  // ==========================
  // REDUX DATA
  // ==========================
  const {
    clubPosts = [],
    postsLoading,
  } = useSelector(
    (state: RootState) =>
      state.club
  );

  // ==========================
  // FETCH CLUB POSTS
  // ==========================
  useEffect(() => {
    if (
      !client_id ||
      Number(client_id) <= 0
    ) {
      return;
    }

    dispatch(
      getClubPublicPosts(
        Number(client_id)
      )
    );
  }, [
    dispatch,
    client_id,
  ]);

  return (
    <>
      <Header />
      <Leftnav />
      <Rightchat />

      <div className="main-content right-chat-active club-posts-main">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="row feed-body">
              <div className="col-xl-8 col-xxl-9 col-lg-8">

                {/* ==========================
                    LOADING
                ========================== */}
                {postsLoading ? (
                  <div className="card border-0 shadow-xss rounded-xxl p-5 text-center">
                    <div className="spinner-border text-primary mb-3" />

                    <h5 className="font-xsss text-grey-600">
                      Loading posts...
                    </h5>
                  </div>
                ) : Array.isArray(
                    clubPosts
                  ) &&
                  clubPosts.length >
                    0 ? (
                  <div>
                    {clubPosts.map(
                      (
                        post: any
                      ) => {
                        const postImage =
                          getUploadUrl(
                            post?.post_image
                          );

                        const postVideo =
                          getUploadUrl(
                            post?.post_video
                          );

                        const galleryImages =
                          Array.isArray(
                            post?.gallery_images
                          )
                            ? post.gallery_images.map(
                                (
                                  img: any
                                ) => ({
                                  ...img,

                                  url:
                                    getUploadUrl(
                                      img?.image ||
                                        img?.url
                                    ),
                                })
                              )
                            : [];

                        const createdTime =
                          post?.created_at
                            ? new Date(
                                post.created_at
                              ).toLocaleString(
                                "en-IN"
                              )
                            : "";

                        return (
                          <div
                            key={
                              post?.post_id
                            }
                            className="mb-4"
                            onClick={(
                              e
                            ) => {
                              const target =
                                e.target as HTMLElement;

                              if (
                                target.closest(
                                  "button"
                                ) ||
                                target.closest(
                                  "a"
                                ) ||
                                target.closest(
                                  "iframe"
                                ) ||
                                target.closest(
                                  "video"
                                )
                              ) {
                                return;
                              }

                              if (
                                !post?.post_id
                              ) {
                                return;
                              }

                              navigate(
                                `/news-details/${post.post_id}`,
                                {
                                  state: {
                                    post,
                                  },
                                }
                              );
                            }}
                            style={{
                              cursor:
                                "pointer",
                            }}
                          >
                            <Postview
                              id={
                                post?.post_id
                              }
                              clientId={
                                post?.client_id
                              }
                              user={
                                post?.client_name ||
                                club?.client_name ||
                                "Club"
                              }
                              role={
                                post?.client_user_role ||
                                post?.role ||
                                ""
                              }
                              time={
                                createdTime
                              }
                              title={
                                post?.title ||
                                post?.short_description ||
                                "Post"
                              }
                              shortDescription={
                                post?.short_description ||
                                ""
                              }
                              category={
                                post?.category_name ||
                                post?.category ||
                                post?.main_category ||
                                "General"
                              }
                              mainCategory={
                                post?.main_category ||
                                "news"
                              }
                              des={
                                post?.post_content ||
                                ""
                              }
                              plainText={stripHtml(
                                post?.post_content ||
                                  ""
                              )}
                              avater="/assets/images/user.png"
                              logo_image={
                                post?.logo_image
                                  ? getUploadUrl(
                                      post.logo_image
                                    )
                                  : undefined
                              }
                              unique_slug={
                                post?.unique_slug ||
                                club?.unique_slug
                              }
                              postimage={
                                postImage
                              }
                              postvideo={
                                postVideo
                              }
                              youtubeUrl={
                                post?.youtube_url ||
                                ""
                              }
                              galleryImages={
                                galleryImages
                              }
                              tags={
                                Array.isArray(
                                  post?.tags
                                )
                                  ? post.tags
                                  : []
                              }
                              comments={
                                Array.isArray(
                                  post?.comments
                                )
                                  ? post.comments
                                  : []
                              }
                              likeCount={Number(
                                post?.like_count ||
                                  0
                              )}
                              commentCount={Number(
                                post?.comment_count ||
                                  0
                              )}
                              shareCount={Number(
                                post?.share_count ||
                                  0
                              )}
                              viewCount={Number(
                                post?.view_count ||
                                  0
                              )}
                              isLiked={Boolean(
                                post?.is_liked
                              )}
                              postType={
                                post?.youtube_url
                                  ? "youtube"
                                  : post?.post_type ||
                                    post?.main_category ||
                                    "text"
                              }
                              onDonate={() => {
                                if (
                                  !post?.post_id
                                ) {
                                  return;
                                }

                                navigate(
                                  `/donate/${post.post_id}`,
                                  {
                                    state: {
                                      donationFrom:
                                        "public",
                                    },
                                  }
                                );
                              }}
                            />
                          </div>
                        );
                      }
                    )}
                  </div>
                ) : (
                  /* ==========================
                      EMPTY
                  ========================== */
                  <div className="card border-0 shadow-xss rounded-xxl p-5 text-center">
                    <i className="feather-file-text font-xxl text-grey-400 mb-3" />

                    <h4 className="fw-700 font-xsss mb-2">
                      No posts found
                    </h4>

                    <p className="font-xssss text-grey-500 mb-0">
                      This club has not
                      added any public
                      posts yet.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Popupchat />
      <Appfooter />

      <style>
        {`
          .club-posts-main {
            min-height: 100vh;
            padding-top: 84px;
            background: #f5f7fb;
          }

          @media (max-width: 1200px) {
            .club-posts-main {
              padding-top: 78px;
            }
          }

          @media (max-width: 991px) {
            .club-posts-main {
              padding-top: 72px;
            }
          }

          @media (max-width: 575px) {
            .club-posts-main {
              padding-top: 16px;
            }
          }
        `}
      </style>
    </>
  );
};

export default ClubPosts;